import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';
import { Fragment } from 'vue-fragment';
import TTag from '~/components/atoms/t-tag.vue';

interface Props {
  fileFormats: string[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 't-format-tags',
  props: {
    fileFormats: null
  },
  setup(__props: any) {

const props = __props as {
  fileFormats: string[];
};



/**
 * These can have a wide variety of names, depending on whether
 * it comes from Algolia or Mongo, and depending what key you use.
 */
const getFormatWithIcon = (format: string) => {
  switch (format) {
    case 'slide':
    case 'Google Slides':
      return {
        title: 'Slide',
        icon: '/images/fa-icons.svg#google',
      };
    case 'sheet':
    case 'Google Sheets':
      return {
        title: 'Sheet',
        icon: '/images/fa-icons.svg#google',
      };
    case 'Google Forms':
      return {
        title: 'Form',
        icon: '/images/fa-icons.svg#google',
      };
    case 'doc':
    case 'docx':
    case 'dot':
    case 'dotx':
    case 'Microsoft Word':
    case 'Microsoft Word (.docx)':
    case 'Microsoft Word Template (.dotx)':
      return {
        title: 'Word',
        icon: '/images/fa-icons.svg#microsoft',
      };
    case 'ppt':
    case 'pptx':
    case 'pot':
    case 'potm':
    case 'potx':
    case 'Microsoft PowerPoint':
    case 'Microsoft PowerPoint (.pptx)':
    case 'Microsoft PowerPoint Template (.potx)':
      return {
        title: 'PowerPoint',
      };
    case 'xls':
    case 'xlsx':
    case 'Microsoft Excel':
    case 'Microsoft Excel (.xlsx)':
      return {
        title: 'Excel',
        icon: '/images/fa-icons.svg#microsoft',
      };
    case 'Portable Graphics Format (.png)':
      return {
        title: 'PNG',
        icon: '/images/fa-icons.svg#image',
      };
    case 'zip':
    case 'Compressed Zip':
    case 'Compressed Zip (.zip)':
      return {
        title: 'ZIP',
        icon: '/images/fa-icons.svg#file',
      };
    case 'Adobe Illustrator (.ai)':
      return {
        title: 'AI',
        icon: '/images/fa-icons.svg#ai',
      };
    case 'pdf':
    case 'Adobe PDF':
    case 'Adobe Reader (.pdf)':
    case 'Printable PDF':
      return {
        title: 'PDF',
        icon: '/images/fa-icons.svg#pdf',
      };
    default:
      return {
        title: format,
        icon: '/images/fa-icons.svg#file',
      };
  }
};
const MAX_FILE_FORMATS = 2;

const formats = computed(() => {
  if (props.fileFormats.length > MAX_FILE_FORMATS) {
    return [{ title: 'Multiple Formats', icon: '/images/fa-icons.svg#file' }];
  }
  return props.fileFormats.map(getFormatWithIcon);
});

return { __sfc: true,props, getFormatWithIcon, MAX_FILE_FORMATS, formats, Fragment, TTag }
}

})